import { Box, Tooltip } from '@mui/material'
import type {
  InternalCalibrationArea,
  InternalLabelArea,
} from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { BBox } from './BBox'

type Props = {
  imageUrl: string
  areas: InternalLabelArea[]
  calibrationAreas: InternalCalibrationArea[]
  onClickArea?: (area: InternalLabelArea) => void
  onClickImage?: () => void
}

/** ラベル画像上で検査箇所を表示するオーバーレイ */
export const BBoxOverlay: FC<Props> = ({
  imageUrl,
  areas,
  calibrationAreas,
  onClickArea,
  onClickImage,
}) => {
  return (
    <Box
      onClick={onClickImage}
      sx={{
        position: 'relative',
        height: 'auto',
        cursor: onClickImage ? 'crosshair' : 'default',
      }}
    >
      <img
        src={imageUrl}
        alt="ラベル画像"
        width="100%"
        crossOrigin="anonymous"
        style={{ objectFit: 'contain', pointerEvents: 'none' }}
      />
      {onClickImage && (
        <Tooltip title="クリックして新しい検査箇所を追加" placement="top" arrow>
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1,
              pointerEvents: 'auto',
            }}
          />
        </Tooltip>
      )}
      {areas.map(area => (
        <BBox
          key={area.id}
          label={area.name}
          tooltip={`検査箇所「${area.name}」を編集`}
          x={area.x}
          y={area.y}
          width={area.width}
          height={area.height}
          color="error"
          onClick={onClickArea ? () => onClickArea(area) : undefined}
        />
      ))}
      {calibrationAreas.map((area, index) => (
        <BBox
          key={area.id}
          label={`${index + 1}`}
          tooltip={`位置補正基準 ${index + 1}`}
          x={area.x}
          y={area.y}
          width={area.width}
          height={area.height}
          color="primary"
        />
      ))}
    </Box>
  )
}
